var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentHeader',{attrs:{"showBack":false,"perfectNavList":_vm.employeeLevel > 50 ? _vm.buPerfectNavList : _vm.rePerfectNavList}}),_c('div',{staticClass:"content-container"},[_c('router-view',{on:{"handleRefresh":_vm.getTodo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }